import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from 'src/@core/common.module';
import { CoreMenuComponent } from './core-menu.component';
import { CoreMenuHorizontalCollapsibleComponent } from './horizontal/collapsible/collapsible.component';
import { CoreMenuHorizontalItemComponent } from './horizontal/item/item.component';
import { CoreMenuVerticalCollapsibleComponent } from './vertical/collapsible/collapsible.component';
import { CoreMenuVerticalItemComponent } from './vertical/item/item.component';
import { CoreMenuVerticalSectionComponent } from './vertical/section/section.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

CoreMenuVerticalSectionComponent;
CoreMenuVerticalItemComponent;
CoreMenuVerticalCollapsibleComponent;

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    // TranslateModule.forChild(),
    CoreCommonModule,
    DirectivesModule,
    NgbTooltipModule,
  ],
  exports: [CoreMenuComponent],
  declarations: [
    CoreMenuComponent,
    CoreMenuVerticalSectionComponent,
    CoreMenuVerticalItemComponent,
    CoreMenuVerticalCollapsibleComponent,
    CoreMenuHorizontalItemComponent,
    CoreMenuHorizontalCollapsibleComponent,
  ],
})
export class CoreMenuModule {}
